module.exports = __webpack_public_path__ + "img/places.014c0ef.svg";